import { render, staticRenderFns } from "./VerifiedBadge.vue?vue&type=template&id=52ef07a1&scoped=true&"
import script from "./VerifiedBadge.vue?vue&type=script&lang=js&"
export * from "./VerifiedBadge.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedBadge.vue?vue&type=style&index=0&id=52ef07a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef07a1",
  null
  
)

export default component.exports